import { GlobalState } from "./types";
import { Layers } from "@/models/map/layers";

export const setLoading = (state: GlobalState, value: boolean) => {
  state.isLoading = value;
};

export const setLoggedIn = (state: GlobalState, value: boolean) => {
  state.isLoggedIn = value;
};

export const setActiveView = (state: GlobalState, value: Layers) => {
  state.activeView = value;
};
